<script setup lang="ts">
import { ref } from 'vue';
import { useModalStore } from '../../ui/modal/modal-store';
import type { ConfirmModalOptions } from '../../ui/modal/types';
import type { EmptyCallback, ParamsCallback } from '../../utils/global-types';

const requestPending = ref(false);
const modal = useModalStore();
const props = defineProps<{
    options: ConfirmModalOptions,
    message: string,
    callback: ParamsCallback,
    close: EmptyCallback
}>();

function cancel() {
    props.callback(false)
    modal.cancel()
}

function confirm() {
    requestPending.value = true;
    props.callback(true)
    props.close()
}

</script>
<template>
    <div>
        <div class="modal-header" v-if="options.title">
            <button type="button" class="close" data-dismiss="modal" @click="cancel" v-if="options.closeButton">
                <i class="fas fa-times"></i>
            </button>
            <h4 class="modal-title">
                {{ options.title }}
            </h4>
        </div>
        <div class="modal-body">
            <div v-html="message"></div>
        </div>
        <div class="modal-footer">
            <button class="btn" :class="options.buttons.cancel.className || ''" @click="cancel">
                {{ options.buttons.cancel.label }}
            </button>
            <button class="btn" :class="options.buttons.confirm.className || ''" @click="confirm"
                :disabled="requestPending">{{ options.buttons.confirm.label }}</button>
        </div>
    </div>
</template>
